const PORTAL_URL = 'https://portal.dia.gov.cz/';
function getHeaderLogoLink() {
  return document.getElementById('home-link');
}
function updateHeaderLogoLink() {
  const link = getHeaderLogoLink();
  if (!link) return;
  link.href = PORTAL_URL;
}
export default function registerHeaderLogoLink() {
  document.addEventListener('click', event => {
    var _event$target$closest, _event$target;
    const link = (_event$target$closest = (_event$target = event.target).closest) == null ? void 0 : _event$target$closest.call(_event$target, '#home-link');
    if (!link) return;
    if (event.ctrlKey || event.metaKey || event.button === 1) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(PORTAL_URL);
  }, true);
  requestAnimationFrame(updateHeaderLogoLink);
}
flarum.reg.add('dia-theme', 'forum/features/header-logo-link', registerHeaderLogoLink);